import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TaskCaseService } from 'src/app/modules/case/services/taskCase.service';
import { DatosMigratorios } from '../../../../interfaces/interaccion-redes-sociales';
import { CaseRecordService } from 'src/app/modules/case/services/case-record.service';
import { CasesService } from 'src/app/core/services/cases.service';

@Component({
  selector: 'app-datos-migratorios',
  templateUrl: './datos-migratorios.component.html',
  styleUrls: ['./datos-migratorios.component.scss'],
})
export class DatosMigratoriosComponent implements OnInit {
  //DATOS TABLA
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  displayedColumns: string[] = [
    'pasaporte',
    'tipo_movimiento',
    'aerolinea',
    'tipo_visa',
    'sello',
    'pais_ciudad_origen',
    'numero_vuelo',
    'fecha_tramite',
    'pais_ciudad_destino',
  ];
  dataSource = new MatTableDataSource<any>();
  tableValues: any[] = [];
  formTable: FormGroup;
  submit = false;

  form: FormGroup;

  @Input() data: { task: any };

  constructor(
    private fb: FormBuilder,
    public taskCaseService: TaskCaseService,
    private caseRecordService: CaseRecordService,
    private caseService: CasesService
  ) {}
  icase;
  get status() {
    return this.icase?.status == 'archived';
  }
  ngOnInit(): void {
    let caseId: any;
    if (typeof this.data.task.case == 'object') {
      caseId = this.data.task.case._id;
    } else if (typeof this.data.task.case == 'string') {
      caseId = this.data.task.case;
    }
    this.caseService.getCase(caseId).subscribe((res) => {
      this.icase = res;
    });
    const { task } = this.data;
    const values = task.data ? task.data : [];
    this.tableValues = values;
    this.formTable = this.fb.group({
      pasaporte: ['', [Validators.required]],
      tipo_movimiento: ['', [Validators.required]],
      aerolinea: ['', [Validators.required]],
      tipo_visa: ['', [Validators.required]],
      sello: ['', [Validators.required]],
      fecha_tramite: ['', [Validators.required]],
      pais_ciudad_origen: ['', [Validators.required]],
      numero_vuelo: [
        '',
        [Validators.required, Validators.pattern(/^[0-9]\d*$/)],
      ],
      pais_ciudad_destino: ['', [Validators.required]],
    });
    this.initializeTable();
  }

  verificateInput(value: string) {
    return (
      this.formTable.get(value)?.invalid &&
      (this.formTable.get(value)?.dirty || this.formTable.get(value)?.touched)
    );
  }

  addData() {
    if (this.formTable.invalid || this.submit) return;
    this.submit = true;
    this.tableValues.unshift(this.formTable.value);
    this.taskCaseService
      .updateTaskCase(this.data.task._id, { data: this.tableValues }) //TODO colocar el last user
      .subscribe(
        (caseUpdated) => {
          this.formTable.reset();
          this.initializeTable();
          this.taskCaseService.taskUpdated.next({ task: caseUpdated });
          this.caseRecordService.updatedRecord.next(true);
        },
        (erorr) => {
          this.submit = false;
        }
      );
  }

  removerCuenta(index: number) {
    this.tableValues.splice(index, 1);
    this.taskCaseService
      .updateTaskCase(this.data.task._id, { data: this.tableValues })
      .subscribe((caseUpdated) => {
        this.initializeTable();
        this.taskCaseService.taskUpdated.next({ task: caseUpdated });
        this.caseRecordService.updatedRecord.next(true);
      });
  }
  initializeTable() {
    this.dataSource = new MatTableDataSource<any>(this.tableValues);
    this.dataSource.paginator = this.paginator;
    this.submit = false;
  }
}
